module.exports = __webpack_public_path__ + "static/img/text.91d6f77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/text.png
// module id = Prft
// module chunks = 1